import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL = "https://hzinyrqqkeqizojcotoj.supabase.co";
const SUPABASE_KEY =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imh6aW55cnFxa2VxaXpvamNvdG9qIiwicm9sZSI6InNlcnZpY2Vfcm9sZSIsImlhdCI6MTcwMjc2Nzk3MSwiZXhwIjoyMDE4MzQzOTcxfQ.w_bZV4jvwiVw4Fhgos9OOr4YpKxlU26p9yvkdvB5AsY";
const supabase = createClient(SUPABASE_URL, SUPABASE_KEY);

export default supabase;
